'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { cn } from '@achra/ui/lib/utils';
import { ArrowRight } from 'lucide-react';
import { useState } from 'react';
import type { ScopeOfWork_Deliverable } from '@/modules/__generated__/graphql/switchboard-generated';
import { KeyResultsModal } from '../key-results-modal/key-results-modal';
import { MetricCard, MetricCardLabel } from '../metric-card/metric-card';
interface KeyResultsMetricCardProps {
  completed: number;
  total: number;
  deliverables: ScopeOfWork_Deliverable[];
}
function KeyResultsMetricCard(t0) {
  const $ = _c(23);
  const {
    completed,
    total,
    deliverables
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleOpen = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsOpen(false);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleClose = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <MetricCardLabel>Key Results</MetricCardLabel>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn("text-base font-semibold tracking-tight");
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== completed) {
    t5 = <span>{completed}</span>;
    $[4] = completed;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== total) {
    t6 = <span className="text-foreground/50"> / {total}</span>;
    $[6] = total;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = <div className="w-full space-y-1">{t3}<div className="flex w-full justify-between"><div className="flex items-baseline gap-2"><div className={t4}>{t5}{t6}</div></div></div></div>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ArrowRight className="size-4" />;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== isOpen) {
    t9 = <div className="flex self-center"><Button variant="outline" size="icon" aria-label="View key results" aria-expanded={isOpen} className="group-hover/metric-card:bg-accent">{t8}</Button></div>;
    $[12] = isOpen;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t7 || $[15] !== t9) {
    t10 = <MetricCard className="group/metric-card hover:bg-accent cursor-pointer transition-colors" onClick={handleOpen}><div className="flex w-full items-start justify-between gap-2">{t7}{t9}</div></MetricCard>;
    $[14] = t7;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== deliverables || $[18] !== isOpen) {
    t11 = <KeyResultsModal deliverables={deliverables} isOpen={isOpen} onClose={handleClose} />;
    $[17] = deliverables;
    $[18] = isOpen;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10 || $[21] !== t11) {
    t12 = <>{t10}{t11}</>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  return t12;
}
export { KeyResultsMetricCard };